import { render, staticRenderFns } from "./RequestDelivery.vue?vue&type=template&id=646a18b4&"
import script from "./RequestDelivery.vue?vue&type=script&lang=js&"
export * from "./RequestDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports